<template>
  <b-row class="select-car-size">
    <b-col cols="12" md="6" v-for="car in carSizes" :key="car.id">
      <div :style="{'margin':'0 auto'}">
        <b-button
          :variant="(car.selected) ? 'primary' : 'secondary' "
          block
          ref="s"
          @click="selectCar(car.id)"
        >
          <div>
            <font-awesome-icon :icon="car.icon" class="text-white" />
          </div>
          <div>{{ car.name }}</div>
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "selectCarSize",
  components: {},
  props: {
    input: String,
    value: String
  },
  watch: {},
  created() {},
  data() {
    return {
      selectedSize: "",
      carSizes: [
        {
          id: "s",
          name: "Standard",
          icon: "standard-car",
          selected: true
        },
        {
          id: "xl",
          name: "XL",
          icon: "xl-car",
          selected: false
        }
      ]
    };
  },
  methods: {
    selectCar(size) {
      let emitSize = '';
      for (let car of this.carSizes) {
          if (car.id == size) {
            car.selected = true;
          } else {
            car.selected = false;
          }
        this.selectedSize = size;
      }
      this.$emit("input", this.enum(this.selectedSize));
    },
    enum(value) {
      let carSize = {
        s: '0',
        xl: '1'
      };
      return String(carSize[value]);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.select-car-size {
  button {
    border: none;
  }
}

</style>
